<header class="page-header">
  <h1>{{ 'page.upload_history.name' | translate | upperFirstLetter }}</h1>
</header>

<fieldset>
  @defer (when uploads.hasValue()) {
    @if (uploadCount() === 0) {
      <app-empty-content-list-element contentType="uploads" />
    } @else {
      <h4>{{ 'upload.history.last_30_days' | translate }}</h4>
      <h3>{{ 'upload.history.count' | translate: { count: uploadCount() } }}</h3>
    }
  } @placeholder {
    <kin-skeleton [height]="1" [width]="12" />
    <kin-skeleton [height]="2" [width]="16" />
  }

  <section>
    @defer (when uploads.hasValue()) {
      @for (upload of uploads.value(); track $index) {
        <div class="upload">
          <div class="content">
            <span
              ><kin-icon [size]="16" [name]="'video'" />{{
                'content_type.' + upload.content_type | translate | upperFirstLetter
              }}
            </span>
            <span
              ><kin-icon [size]="16" name="upload" />
              {{ 'upload.history.upload_date' | translate | upperFirstLetter }}
              <span class="created-at"> {{ upload.created_at | date: 'shortDate' }}</span>
            </span>
            <h4>{{ upload.title }}</h4>
            <div class="image-wrapper" [ngClass]="{ available: upload.status === 'VIDEO_STORED' }">
              @if (upload.thumnail_url) {
                <img [src]="upload.thumnail_url" [alt]="upload.title" />
              } @else {
                <span
                  class="thumnail-placeholder"
                  [style.background]="colorService.brandSecondary100()"
                >
                  <kin-icon name="picture" [color]="colorService.neutral300()" />
                </span>
              }
            </div>
            @if (upload.status === 'VIDEO_STORED') {
              <p>{{ 'upload.history.available_hint' | translate }}</p>
            }
          </div>
          <app-upload-status [status]="upload.status" />
        </div>
        @if (!$last) {
          <div class="divider"></div>
        }
      }
    } @placeholder {
      @for (_ of [].constructor(5); track $index) {
        <div class="upload">
          <div class="content">
            <span>
              <kin-skeleton [height]="16" [width]="16" unit="px" />
              <kin-skeleton [height]="12" [width]="80" unit="px" />
            </span>
            <span>
              <kin-skeleton [height]="16" [width]="16" unit="px" />
              <kin-skeleton [height]="12" [width]="60" unit="px" />
            </span>
            <h4>
              <kin-skeleton [height]="1.2" [width]="18" />
            </h4>
            <div class="image-wrapper">
              <kin-skeleton [width]="80" [height]="56" unit="px" />
            </div>
            <kin-skeleton [height]="0.7" />
          </div>
          <kin-skeleton [height]="3" [width]="18" [borderRadius]="100" />
        </div>
        @if (!$last) {
          <div class="divider"></div>
        }
      }
    }
  </section>
  <!-- <app-paginator /> -->
</fieldset>
